import React, {useState, useCallback, useContext} from "react";
import {BreakpointContext} from "@core-ui/breakpoint-provider";
import {AccordionProps, ChangeHandler} from "./types";
import {AccordionContext} from "./AccordionContext";

export function Accordion({
  children,
  crossBrand = false,
  defaultExpanded = [],
  expanded: expandedProp,
  onChange,
  singlePanelExpanded = false,
  unstyled = false,
  withChevron,
  withPlusMinus,
  sticky,
  snap,
  snapToTopOnClose,
}: AccordionProps): JSX.Element {
  const {minWidth} = useContext(BreakpointContext);
  const [expandedPanels, setExpanded] = useState<string[]>(defaultExpanded);

  const expanded = expandedProp ?? expandedPanels;

  const handleChange = useCallback<ChangeHandler>(
    (event, panelId) => {
      if (panelId) {
        const expandedPanel = expanded.includes(panelId) ? "" : panelId;
        // If the accordion is set to singlePanelExpanded, only allow one item in the expandedPanels array at a time
        if (singlePanelExpanded) setExpanded([expandedPanel]);
        else if (expandedPanels.includes(panelId)) {
          // If the panel already exists in the expandedPanels array, remove it
          setExpanded(expandedPanels.filter((p) => p !== panelId));
        } else {
          // Otherwise add it to the expandedPanels array
          setExpanded([...expandedPanels, expandedPanel]);
        }
        onChange?.(event, expandedPanel);
      }
    },
    [onChange, expanded, expandedPanels, singlePanelExpanded]
  );

  return (
    <AccordionContext.Provider
      value={{
        crossBrand,
        expanded,
        minWidth,
        onChange: handleChange,
        unstyled,
        withChevron,
        withPlusMinus,
        snap,
        snapToTopOnClose,
        sticky,
      }}
    >
      {children}
    </AccordionContext.Provider>
  );
}
